<template>
  <div class="container">
    <header>
      <h1 style="padding:2%">Welcome to the Spanish Quiz</h1>
      <div class="row">
        <div class="col-md">
          <p>Welcome to the fast-paced quiz where YOU get to choose on what YOU work on! 🫵🏻</p>

              <p>No more owls telling you what to do - TWIT-OFF! 🦉 </p>

              <p>Submit your top scores to the leaderboard - ¡VAMOS CAMPEÓN! 🙌🏻</p>

              <p>Battle your mates (on the stuff you know best obviously - a W is a W ¿no?) 👊🏻</p>

              <p>See your mistakes to know what to do for next time! 👌🏻</p>

              <p>Embed the Spanish you probably ought to know by doing rounds on that topic! 🇪🇸</p>

              <p>See your stats improve - let them decide what you work on next! 📈</p>
        </div>
        <div class="col-md"><img src="@/assets/logo-grey.jpeg" style="width: 100%;"/></div>
      </div>
     
      
    </header>
  </div>
</template>
<style>
.col-md p{
  font-size: 2em;
  padding: 1%;
}
</style>
<script>

import UserService from "../services/user.service";

export default {
  name: "Home",
  data() {
    return {
      content: "Welcome to the Spanish Quiz",
    };
  },
  mounted() {
    UserService.getPublicContent().then(
      (response) => {
        this.content = response.data;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};
</script>
